/* eslint-disable  */
import axios from 'axios';
import getURLParams from '../lib/get-url-params';
const LOAD = 'scratch-gui/cs2n/LOAD_CS2N_ELEMENT_DATA';
const AWARD = 'scratch-gui/cs2n/AWARD';
const CONTENT = 'scratch-gui/cs2n/CONTENT';
const initialState = {
    content: [{ title: "Please wait", body: "<div>The Virtual Robot Simulation window is loading.</div>" }]
};

// POST Request to cs2n requesting an array of content elements

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
        case LOAD:
            return { ...state, config: action.payload };
        case AWARD:
            return { ...state, award_status: action.payload };
        case CONTENT:
            return { ...state, content: action.payload };
        default:
            return state;
    }
};

const requestConfig = function () {
    const { token } = getURLParams();
    return {
        headers: {
            'Authorization': `Bearer ${token}`,
            'content-type': 'multipart/form-data',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    };
};
const getGenericContent = function (ids) {
    const { id, baseUrl } = getURLParams();
    return dispatch => {
        axios
            .get(
                `${baseUrl}/client_api/v1/get_generic_content/${id}/${ids}`,
                requestConfig()
            )
            .then(r => {
                // Sort the array back to the ids since ruby sorts them by id number
                // TODO: fix this on ruby's side
                const contentList = new Array();
                for (let i = 0; i < ids.length; i++) {
                    const tartgetID = ids[i];

                    for (let j = 0; j < r.data.length; j++) {
                        const id = r.data[j].id;
                        if (id == tartgetID) {
                            contentList.push(r.data[j]);
                        }
                    }

                }
                dispatch({ type: CONTENT, payload: contentList });

            })
            .catch(r => console.warn('cs2n:  generic content error', r));
    };
};
const loadCS2NElementConfig = function () {
    const { id, baseUrl } = getURLParams();
    return dispatch => {
        axios
            .get(`${baseUrl}/client_api/v1/cmra_blocks/${id}`, requestConfig())
            .then(r => {
                console.log("CS2N Config");
                awardCS2NElementRequirement();
                dispatch({ type: LOAD, payload: r.data });

            })
            .catch(r => console.log('cs2n: load config error', r));
    };
};
const awardCS2NElementRequirement = function () {
    const api = apiHelper("complete_cmra_blocks");
    console.log("Rewarding Progress");
    axios.post(api.url, {}, api.header).then(r => {
        // console.log({
        // 	type: "AWARD", payload: r.data.message
        // });
    }).catch(r => console.log('cs2n: award element error', r));
};

const apiHelper = (method) => {
    const { baseUrl, token, id } = getURLParams();
    if (id == null) {
        return null;
    }
    var api = {
        url: `url`,
        header: {
            headers: {
                'Authorization': `Bearer ${token}`,
                'content-type': 'multipart/form-data',
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }
    }

    switch (method) {
        case 'save_program':
            api.url = `${baseUrl}/client_api/v1/save_program/${id}/1/${cs2nConfig.id}`
            break;
        case 'load_programs':
            api.url = `${baseUrl}/client_api/v1/get_projects_by_activity/${id}/${cs2nConfig.id}`
            break;
        case 'complete_cmra_blocks':
            api.url = `${baseUrl}/client_api/v1/complete_unity_game_element_requirement/${id}`;
            break;
        case 'reset_program':
            api.url = `${baseUrl}/client_api/v1/get_default_program/${id}`;
            break;
    }
    return api;
}


export {
    reducer as default,
    loadCS2NElementConfig,
    getGenericContent,
    awardCS2NElementRequirement
};
